<template>
    <div class="page-content" style="padding-bottom:10px !important;">
        <div class="d-flex justify-content-between align-items-center flex-wrap mb-4">
            <div class="my-2">
                <h3 class="mb-2 mb-md-0">Integration</h3>
            </div>
        </div>
        <div class="card-grid">

            <div class="company-card" v-for="item in integrationList" :key="item.name" @click="goToDetails(item.name)">
                <div class="d-flex align-items-center justify-content-center mb-2">
                    <img :src="item.logo" :alt="`${item.name}`" class="card-logo">
                    <span class="card-title">{{ item.name }}</span>
                </div>
                <p class="mb-0" style="text-align: justify;">{{ item.desc }}</p>
            </div>
        </div>

    </div>
</template>
<script>
export default {
    data() {
        return {
            integrationList: [
            { 
                name: 'LTI-1.3', logo: '/assets/Images/LTILogo.jpg',
                desc: 'The latest version of the 1EdTech standard for integrating learning tools with learning management systems (LMS)' },
   
            ],
            routeSearch: '',
            routeOffset: '',
            routeIntegration: ''
        };
    },
    methods: {
        goToDetails(item) {
            this.routeIntegration = item;
            this.$router.push({
                name: 'IntegrationDetails',
                params: { integrationName: item },
                query: {
                    integration: this.routeIntegration ? encodeURIComponent(this.routeIntegration) : '',
                },
            });
        }
    }
};
</script>
<style>
.tab-selector {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    background-color: #f1f0ff;
    margin: 24px 0px;
    padding: 8px 16px;
    border-radius: 5px;
    width: fit-content;
}

.card-grid {
    display: grid;
    gap: 20px;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
}

.company-card {
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 20px;
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    transition: transform 0.2s;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.company-card:hover {
    transform: scale(1.02);
}

.card-logo {
    max-width: 70px;
    height: auto;
    /* margin-bottom: 10px; */
}

.card-title {
    font-size: 18px;
    font-weight: 600;
    margin: 0 !important;
    color: #333;
    white-space: wrap;
    padding: 0 !important;
    border: none !important;
}

@media (min-width: 1024px) {
    .card-grid {
        grid-template-columns: repeat(3, 1fr);
    }
}

@media (min-width: 481px) and (max-width: 1023px) {
    .card-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 480px) {
    .card-grid {
        grid-template-columns: repeat(1, 1fr);
    }
}
</style>